const STATS = [
  { n: '28', suffix: 'ans', label: "d'engagement à Casablanca" },
  { n: '4', suffix: 'campus', label: 'à Casablanca Oulfa' },
  { n: '3–18', suffix: 'ans', label: 'De la maternelle au Bac' },
];

const TrustBar = () => (
  <section className="trustbar">
    <div className="container">
      <ul className="trustbar-grid">
        {STATS.map((s) => (
          <li className="trustbar-item" key={s.label}>
            <div className="trustbar-num">
              <span className="trustbar-num-big">{s.n}</span>
              <span className="trustbar-num-suffix">{s.suffix}</span>
            </div>
            <p className="trustbar-label">{s.label}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustBar;
